import { render, staticRenderFns } from "./SampleDetailsForm.vue?vue&type=template&id=b0a29920&scoped=true&"
import script from "./SampleDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./SampleDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./SampleDetailsForm.vue?vue&type=style&index=0&id=b0a29920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a29920",
  null
  
)

export default component.exports